package horcrux.browserapp.views.org

import horcrux.frontend.common.GlobalAppState
import horcrux.frontend.common.Route
import horcrux.frontend.common.navigate
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.launch
import react.FC
import react.Props

external interface LandingPageProps : Props {
    var globalAppState: GlobalAppState
}

val LandingPage = FC<LandingPageProps> { props ->
    props.globalAppState.analyticsClient.log(Route.LANDING_PAGE.pageViewEvent)
    val navigate = props.navigate
    // This must be done in a background thread for some reason
    GlobalScope.launch { Route.CHAT_WITH_YOUR_COLLECTION.navigate(navigate) }
}
